import { Component } from '@angular/core';
import { LinkButtonDirective } from '../../shared/directives/link-button.directive';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ParagraphDirective } from '../../shared/directives/paragraph.directive';
import { StandardButtonDirective } from '../../shared/directives/standard-button.directive';
import { CmsTextPipe } from '../../pipes/cms-text.pipe';

@Component({
  selector: 'app-gamtest-start',
  standalone: true,
  imports: [CommonModule, RouterLink, ParagraphDirective, StandardButtonDirective, LinkButtonDirective, CmsTextPipe],
  templateUrl: './gamtest-start.component.html',
  styleUrl: './gamtest-start.component.scss'
})
export class GamtestStartComponent {

}
